<template>
<div class="LiquidLevelCard">
  <div class="devcieContainer" :style="styleObject" v-if="JSON.stringify(tabData) == '{}'">
    <!-- <h4>设备列表</h4> -->
    <div class="treeAside">
      <div class="treeTop">
        <span class="treeTopTitle">区域</span>
      </div>
      <div class="treeBox">
        <el-tree
          lazy
          :load="loadData"
          :props="props"
          v-if="1"
          class="tree"
          ref="tree"
          :indent="6"
          node-key="value"
          highlight-current
          :expand-on-click-node="false"
          @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree>        
        <!-- <el-tree v-if="1" class="tree" ref="tree" :indent=6 :data="treeData" how-checkbox node-key="value" default-expand-all highlight-current :expand-on-click-node="false" @node-click="handleNodeSelect">
          <span class="custom-tree-node" slot-scope="{ node }">
            <el-tooltip :content="node.label" placement="right-end" effect="light" :visible-arrow="true">
              <span class="treeLabel" style="width:190px">{{ showLabel(node.label) }}</span>
            </el-tooltip>
          </span>
        </el-tree> -->
      </div>
    </div>
    <div class="container">
      <div class="query">
        <div class="queryCons">
          <el-input class="common" placeholder="设备名称/设备类型/IMEI" autocomplete="off" v-model="searchText" style="width:200px;"></el-input>
          <el-select class="common" v-model="keyWords.isInstall" placeholder="是否安装" clearable>
            <el-option label="已安装" :value="1"></el-option>
            <el-option label="未安装" :value="0"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isRegist" placeholder="是否注册" clearable>
            <el-option label="已注册" :value="1"></el-option>
            <el-option label="未注册" :value="0"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isOnline" placeholder="是否在线" clearable>
            <el-option label="在线" :value="true"></el-option>
            <el-option label="离线" :value="false"></el-option>
          </el-select>
          <!-- <el-select class="common" v-model="keyWords.typeId" placeholder="设备类型" clearable>
            <el-option v-for="(item,i) in deviceTypeList" :key="i" :label="item.name" :value="item.id"></el-option>
          </el-select> -->
          <el-select class="common" v-model="keyWords.isAlarm" placeholder="是否报警" clearable>
            <el-option label="报警" :value="true"></el-option>
            <el-option label="未报警" :value="false"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isFault" placeholder="是否故障" clearable>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
          <el-button
            class="common"
            type="primary"
            size="medium"
            @click="serachData"
            icon="el-icon-search">搜索</el-button>
          <el-button class="delSome" type="primary" size="medium" @click="changeRightCons" icon="el-icon-s-data">实时统计</el-button>
          <!-- <button class="primaryBtn common" @click="serachData">搜索</button>
          <button class="delSome" @click="changeRightCons" v-show="!isMobile">
            <i class="imgShow" :class="changeStatus?'active':''"><img src="../../assets/img/deviceGas/open.png" alt=""></i>
            <span>{{changeStatus?'收起统计':'展开统计'}}</span>
          </button> -->
        </div>
      </div>
      <div class="listsContainer" :style="styleObjectCons">
        <!-- :class="changeStatus?'':'active'" -->
        <div class="listsLeft">
          <el-scrollbar wrap-class="scrollbar-wrapper" v-loading="tableLoading">
            <ul class="clearfix device-cardList">
              <li :class="['device-card', item.isOnline == '离线' ? 'out-card' : item.isAlarm == '报警中' ? 'alarm-card' : '']" v-for="(item,index) in dataList" :key="index"><!--  -->
                <h6>
                  <span class="title overText">{{item.name}}</span>
                  <div class="title-right">
                    <!-- <p class="sign">
                      <span
                        v-for="item1 in item.sign"
                        :key="item1"></span>
                    </p> -->
                    <span class="vol">{{item.voltage}}%</span>
                    <span class="electric">
                      <i :style="{width: item.voltage + '%'}"></i>
                      <img v-if="item.isOnline == '离线'" src="../../assets/img/devicetype/electric-gray.png" alt="" />
                      <img v-else src="../../assets/img/devicetype/electric-gray.png" alt="" />
                    </span>
                    <span class="set" @click="clickEven(item)">
                      <i class="el-icon-edit-outline"></i>
                    </span>
                    <!-- 设置按钮 -->
                    <span class="set" @click="handleClickSet(item)">
                      <i class="el-icon-s-tools"></i>
                    </span>
                  </div>
                </h6>
                <div class="chart-item">
                  <div class="chart">
                    <div class="value">{{item.channelVal || '--'}}m</div>
                    <div class="tong-box">
                      <img src="../../assets/img/devicetype/tong.png" alt="" class="tong">

                      <div class="water-level-box">
                        <dv-water-level-pond
                          :config="{
                            data: [item.rangeValue ? ((item.channelVal / item.rangeValue) * 100).toFixed(1) : 0 || 0],
                            waveNum: 1,
                            waveOpacity: 1,
                            colors: ['#46E2F9'],
                            waveHeight:5
                          }"
                          style="width:73px;height:86px;top:0px;left:-1px" />
                        <p>{{item.rangeValue ? ((item.channelVal / item.rangeValue) * 100).toFixed(1) : 0 || 0}}%</p>
                      </div>
                      <!-- <img src="../../assets/img/devicetype/long-line.png" alt="" class="long-line"> -->
                    </div>
                    <p class="status">{{(item.isOnline == '在线' && item.isAlarm == '报警中') ? '报警中' : item.isOnline }}</p>
                    <!-- <p class="range">
                      <span v-for="(item, i) in item.range" :key="i">
                        {{item}}
                      </span>
                    </p> -->
                  </div>
                  
                  <div class="device-params">
                    <div>
                      <p class="params-t">设备编号</p>
                      <el-tooltip effect="light" :content="item.imei" placement="right">
                        <p class='overText'>{{item.imei}}</p>
                      </el-tooltip>
                    </div>
                    <div>
                      <p class="params-t">阈值上限</p>
                      <p class='overText'>{{item.thresholdHig || '-'}}m</p>
                    </div>
                    <div>
                      <p class="params-t">阈值下限</p>
                      <p class='overText'>{{item.thresholdLower || '-'}}m</p>
                    </div>
                    <div>
                      <p class="params-t">安装时间</p>
                      <p class="time-t">{{item.createTime}}</p>
                    </div>
                    <!-- <div>
                      <p class="params-t">sim卡余期</p>
                      <p>{{item.day}}天</p>
                    </div> -->
                  </div>
                </div>
              </li>
            </ul>
          </el-scrollbar>
          <div class="noData" v-if="!(dataList&&dataList.length)&&consShow">
            <img src="../../assets/img/noData.png" alt="">
            <div class="tip">暂无数据</div>
          </div>
          <div class="cardPage">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.currentPage"
              :page-sizes="pagination.pageSizes"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total">
            </el-pagination>
          </div>
        </div>
        <div class="maskingRight" v-if="changeStatus">
          <div class="listsRight" :class="showSlid?'component-slid-open' : 'component-slid-out'">
            <div class="messContainer">
              <div class="cons">
                <device-right-cons :typeId="7" @closeRightCons="closeRightCons"></device-right-cons>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mainContent" :style="styleObject" v-if="JSON.stringify(tabData) != '{}'">
    <div class="navShow">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <template v-if="JSON.stringify(tabData) != '{}'">
          <el-breadcrumb-item :to="{ path: '/liquidLevel' }">
            <span @click="jumpDev">设备列表</span>
          </el-breadcrumb-item>
          <!-- <el-breadcrumb-item :to="{ path: '/deviceGas' }">
            <span @click="jumpDev">设备信息</span>
          </el-breadcrumb-item> -->
          <template>
            <el-breadcrumb-item>{{tabData.name}}</el-breadcrumb-item>
          </template>
        </template>
      </el-breadcrumb>
    </div>
    <div class="tabBox">
      <tab-block @tabToggle="toggleCom" :pageType="pageType" :tabs="tabs"></tab-block>
    </div>
    <div class="main">
      <component :is="component" :deviceId="deviceId" :deviceImei="deviceImei" type="liquid"></component>
    </div>
  </div>
  <el-dialog title="设置" :visible.sync="dialogVisible" width="400px">
    <ul class="edit-dialog">
      <!-- <li>
        <span class="title">名称</span>
        <el-input placeholder="请输入名称" v-model.trim="editData.name" clearable maxlength="10">
        </el-input>
      </li> -->
      <li>
        <span class="title">容器高度 </span>
        <el-input-number v-model="editData.rangeValue" :min="0"></el-input-number>
        <span> m</span>
      </li>
      <li>
        <span class="title">阈值下限值 </span>
        <el-input-number v-model="editData.thresholdLower" :min="0"></el-input-number>
        <span> m</span>
      </li>
      <li>
        <span class="title">阈值上限值 </span>
        <el-input-number v-model="editData.thresholdHig" :min="0"></el-input-number>
        <span> m</span>
      </li>
      <li>
        <span class="title">动态阈值 </span>
        <el-input-number v-model="editData.wave" :min="0"></el-input-number>
        <span> m</span>
      </li>
    </ul>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSave()">保 存</el-button>
    </span>
  </el-dialog>
  <el-dialog title="设置报警提示语音" :visible.sync="dialogFormVisible" width="500px" @close="handleClosed('yuyinForm')">
    <el-form :model="yuyinForm" :rules="rules" ref="yuyinForm">
      <el-form-item label="提示语音" prop="content">
        <el-input v-model="yuyinForm.content"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmitYuyin('yuyinForm')">确 定</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import TabBlock from '@/components/common/TabBlock'
import BasicInfo from '@/views/deviceManagement/deviceDetails/BasicInfo'
import DeviceDatas from '@/views/deviceManagement/deviceDetails/DeviceDatas'
import IssueCommand from '@/views/deviceManagement/deviceDetails/IssueCommand'
import AlarmRecord from '@/views/deviceManagement/deviceDetails/AlarmRecord'
import FaultRecord from '@/views/deviceManagement/deviceDetails/FaultRecord'
import InstallRecord from '@/views/deviceManagement/deviceDetails/InstallRecord'
import DeviceRightCons from '@/views/deviceManagement/gatewayChild/DeviceRightCons'
import Card from '@/components/common/Card'
export default {
  name:'DeviceGas',
  components: {
    TabBlock,
    BasicInfo,
    DeviceDatas,
    IssueCommand,
    AlarmRecord,
    FaultRecord,
    InstallRecord,
    Card,
    DeviceRightCons
  },
  data() {
    return {
      yuyinForm: {
        content: '',
        deviceId: null,
      },
      rules: {
        content: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 25, message: '长度在 3 到 25 个字符', trigger: 'blur' }
        ],
      },
      dialogFormVisible: false,
      treeData: [],
      searchText: '',
      keyWords: {
        isAlarm: "",
        isFault: "",
        isInstall: "",
        isOnline: "",
        isRegist: "",
        typeId: ''
      },
      options: [{
          value: '1',
          label: '在线'
        }, {
          value: '0',
          label: '离线'
        }
      ],
      component: '',
      tabs: [{
        name: '基本信息',
        code: 'BasicInfo'
      }, {
        name: '设备数据',
        code: 'DeviceDatas'
      }, 
      // {
      //   name: '下发命令',
      //   code: 'IssueCommand'
      // },
      {
        name: '报警记录',
        code: 'AlarmRecord'
      }, {
        name: '故障记录',
        code: 'FaultRecord'
      }, {
        name: '安装记录',
        code: 'InstallRecord'
      }],
      pageType: 'DeviceGas',
      styleObject: {
        height: ''
      },
      styleObjectCons: {
        height: ''
      },
      tabData: {},
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 12,
        pageSizes: [12,22,32],
        total: 0
      },
      dataList: [],
      deviceTypeList: [],
      fields:[],
      tableLoading: true,
      deviceId: null,
      getEchartStatus: '',
      deviceImei: '',
      changeStatus: false,
      consShow: false,
      currentTreeId: '',
      showSlid: false,
      isMobile: false, // 是否是终端设备
      props: {
        label: 'label',
        children: 'children',
        isLeaf: 'isLeaf'
      },
      dialogVisible: false,
      editData: {},
    }
  },
  created() {
    this.makeheight()
    this.makeheightCons()
    // this.queryTreeNode()
    // this.initData()
    this.getDeviceType()
  },
  methods: {
    showLabel(label) {
      if (!label) {
        return label;
      }
      return label;
    },
    // // 查询组织
    // queryTreeNode(pid = 0) {
    //   this.request.get(`/front/system/organization/findTreeById?id=${pid}`)
    //     .then(rs => {
    //       // console.log(rs);
    //       this.treeData = rs.code === 200 ? rs.data : [];
    //       this.currentTreeId = this.treeData.length > 0 ? this.treeData[0].value : 0;
    //     })
    //     .catch(error => (this.treeData = []));
    // },
    // 查询区域
    queryTreeNode(pid = 0) {
      this.request.get(`/front/device/region/findTreeById?id=${pid}`)
        .then(rs => {
          // console.log(rs);

          this.treeData = rs.code === 200 ? rs.data : [];
          // this.treeData.push({
          //   children: [],
          //   id: 'mobile',
          //   label: "终端出库设备",
          //   parentId: 0,
          //   serial: 51,
          //   tenantId: null,
          //   terminalFlag: null,
          //   value: 0
          // })
          this.currentTreeId = this.treeData.length > 0 ? (this.treeData[0].value?this.treeData[0].value:0):0;
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.treeData[0].value)
          })
          this.initData()
        })
        .catch(error => (this.treeData = []));
    },
    // 查询区域
    loadData (node, resolve) {
      if (node.level === 0) {
        let root = { id: 0, label: '区域机构', parentId: 0, value: 0 }
        
        //默认展开第一层根节点---节点渲染完成后，加载第二层节点的核心代码
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(0)
          let nodedata = node.childNodes[0];
          nodedata.expanded = true;
          nodedata.loadData();
        })
        resolve([root])
      } else {
        let pid = node.data ? node.data.id : 0

        this.request.get(`/front/device/region/findTreefenjiById?id=${pid}`).then(rs => {

          // let data = rs.code === 200 ? rs.data : []
          let data = []
          if (rs.code == 200) {
            data = rs.data || []
          }

          // 区域-终端出库设备
          if (node.level == 1) {
            data.unshift({ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true })
          }

          this.initData()
          resolve(data)
          
        }).catch(error => {
          console.error(error)
          let temp = node.level == 1 ? [{ id: -1, label: '终端出库设备', parentId: 0, value: -1, isLeaf: true }] : []
          resolve(temp)
          // resolve([])
        })        
      }
    },    
    // 节点点击发生变化时，触发事件
    handleNodeSelect(item) {
      this.isMobile = item.id == 'mobile'
      this.currentTreeId = item ? (item.value ? item.value : 0) : 0;
      this.pagination.currentPage = 1;
      this.initData();
    },
    getDeviceType() {
      this.request.post('/front/device/type/query', {
        page: 1,
        pageSize: 1000
      }).then(res => {
        // console.log(res);
        if (res.code === 200) {
          this.deviceTypeList = res.data.data?res.data.data:[]
        } else if (res.code === 500) {
          this.deviceTypeList = []
          this.msg.warn(res.msg)
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    serachData() {
      //查询//搜索
      this.getEchartStatus = this.keyWords.typeId
      this.searchText = this.searchText.replace(/(^\s*)|(\s*$)/g, "")
      this.pagination.currentPage = 1
      this.initData()
    },
    initData() {
      this.consShow = false

      let { searchText, currentTreeId, pagination: { currentPage, pageSize }, keyWords: { typeId, isInstall, isAlarm, isFault, isRegist, isOnline } } = this

      let params = {
        key: searchText,
        page: currentPage,
        pageSize,
        orgId: currentTreeId || 0,
        typeId,
        isInstall,
        isAlarm,
        isFault,
        isRegist,
        isOnline,
      }
      let url = params.orgId == -1 ? '/front/device/liquid/queryOutbound' : '/front/device/liquid/query'
      this.request.get(url, params)
        .then(res => {
          if (res.code === 200) {
            this.tableLoading = false
            this.consShow = true
            this.dataList = res.data ? res.data : []

            this.pagination.total = res.total
          } else if (res.code === 500) {
            this.dataList = []
            this.msg.warn(res.msg)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    jumpDev() {
      this.tabData = {}
      this.initData()
    },
    toggleCom(tabCode) {
      console.log(tabCode);
      this.tabData = tabCode
      this.component = tabCode.code
    },
    clickEven(val) {
      this.tabData = {
        name: '基本信息',
        code: 'BasicInfo'
      }
      this.deviceId = val.deviceId
      this.deviceImei = val.imei
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和makeheightCons
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    makeheightCons(height = 205) {
      let _this = this;
      _this.styleObjectCons.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObjectCons.height = window.innerHeight - height + "px";
        })();
      };
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.initData()
    },
    handleSizeChange(val) {
      this.pagination.currentPage = 1
      this.pagination.pageSize = val
      this.initData()
    },
    changeRightCons(){
      if(!this.changeStatus){
        this.changeStatus = true
        this.showSlid=true
      } else {
        this.showSlid=false
        setTimeout(() => {
          this.changeStatus = this.showSlid
        },440)
      }
    },
    closeRightCons(data){
      this.showSlid = false
        setTimeout(() => {
          this.changeStatus = data
        }, 440)
    },
    // 打开语音设置弹窗
    handleOpenyuyin (data) {
      console.log(777, data.deviceId)
      this.yuyinForm.deviceId = data.deviceId
      this.dialogFormVisible = true
    },
    // 提交语音播报信息
    handleSubmitYuyin (yuyinForm) {
      this.$refs[yuyinForm].validate((valid) => {
        if (valid) {
          this.request.post(`/front/device/akey/${this.yuyinForm.deviceId}/${this.yuyinForm.content}`).then(res => {
            if (res.code == 200) {
              this.msg.success('播报语音设置成功')
              this.dialogFormVisible = false
            } else {
              this.msg.error(res.msg)
            }
          })
        } else {
          this.msg.error('提交失败,请按照要求填写正确信息！')
          return false
        }
      })
    },
    // 弹窗关闭时触发
    handleClosed (yuyinForm ) {
      this.yuyinForm.content = ''
      this.$refs[yuyinForm].resetFields()
    },
    /**
     * @Description 
     * @Author      YOYO
     */
    handleClickSet (item) {
      // if (item.isOnline == '离线') return this.$message({ type: 'warning', message: '离线状态下不允许操作设备' })
      let { deviceId, rangeValue, thresholdLower, thresholdHig, wave } = item

      this.dialogVisible = true
      this.editData = {
        deviceId,
        rangeValue,
        thresholdLower,
        thresholdHig,
        wave
      }
    },
    /**
     * @Description 设置保存
     * @Author      YOYO     -             2021-11-27
     */
    async handleSave () {
      let { deviceId, rangeValue, thresholdLower, thresholdHig, wave } = this.editData
      if (rangeValue === '' || thresholdLower === '' || thresholdHig === '' || wave === '') {
        return this.$message({ type: 'warning', message: '请填写完整！' })
      }
      let params = {
        deviceId,
        rangeValue,
        alarmsTh: `${thresholdLower},${thresholdHig},${wave} `
      }
      let { code, msg } = await this.request.get(`/front/device/liquid/command`, params)
      if (code == 200) {
        this.dialogVisible = false
        this.initData()
        this.$message({ type: 'success', message: '下发成功' })
      } else {
        this.$message({ type: 'warning', message: msg })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.LiquidLevelCard {
  position: relative;
  .devcieContainer{
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
    h4 {
      padding-bottom: 10px;
    }
    .container {
      padding-left: 260px;
    }
    .query {
      padding-bottom: 10px;
      .queryCons{
        width: 100%;
        overflow: hidden;
        .common{
          float: left;
          margin-bottom: 5px;
        }
        .primaryBtn{
          width: 82px;
          height: 36px;
          cursor: pointer;
          margin-right: 20px;
          font-size: 14px;
          line-height: 36px;
          border: 0;
          color: #FFFFFF;
          background: #1089FF;
          border-radius: 2px;
          &:hover {
            background: #0774e0;
          }
        }
        .delSome{
          // width: 102px;
          // cursor: pointer;
          float: right;
          // font-size: 0;
          // padding: 0 10px;
          // border: 0;
          // color: #FFFFFF;
          // background: #1089FF;
          // border-radius: 2px;
          // outline: unset;
          // overflow: hidden;
          // &:hover{
          //   background: #0774e0;
          // }
          // .imgShow{
          //   float: left;
          //   width: 16px;
          //   height: 16px;
          //   margin:10px 6px 0 0;
          //   img{
          //     width: 100%;
          //     height: 100%;
          //     vertical-align: middle;
          //   }
          //   &.active{
          //     transform: rotate(180deg);
          //   }
          // }
          // span{
          //   float: left;
          //   font-size: 14px;
          //   line-height: 36px;
          // }
        }
      }
    }
    .listsContainer {
      overflow: hidden;
      position: relative;
      .listsLeft {
        float: left;
        width: 100%;
        height: 100%;
        box-sizing:border-box;
        padding: 0 0 60px;
        position: relative;
        background: #f2f2f2;
        .noData{
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -150px;
          margin-top: -150px;
          text-align: center;
          img{
            width: 300px;
            height: 300px;
          }
          .tip{
            margin-top: 10px;
            font-size: 18px;
            color: #bbb;
          }
        }
        .device-cardList {
          height: 100%;
          width: 100%;
          overflow-x: hidden;
          overflow-y: auto;
          font-size: 14px;
          // display: flex;
          // flex-wrap: wrap;
          // justify-content: space-between;
          .device-card {
            position: relative;
            display: inline-block;
            border: 1px solid #E1E1E1;
            background: #fff;
            width: 350px;
            // min-width: 240px;
            height: 264px;
            padding: 5px 10px;
            margin-top: 10px;
            margin-left: 20px;
            h6 {
              height: 28px;
              line-height: 28px;
              border-bottom: 1px solid #E1E1E1;
              overflow: hidden;
              .title {
                font-size: 18px;
                color: #000;
                display: inline-block;
                width: 60%;
              }
              .title-right {
                font-size: 12px;
                float: right;
                color: #178FFD;

                .sign {
                  display: inline-block;
                  margin-right: 4px;
                  vertical-align: -1px;
                  span{
                    display: inline-block;
                    height: 12px;
                    border: 1px solid #178FFD;
                    margin-right: 1px;
                    &:nth-child(1) {
                      height: 4px;
                    }
                    &:nth-child(2) {
                      height: 6px;
                    }
                    &:nth-child(3) {
                      height: 8px;
                    }
                    &:nth-child(4) {
                      height: 10px;
                    }
                  }
                }
                .vol {
                  vertical-align: 3px;
                }
                .electric {
                  position: relative;
                  top: -5px;
                  display: inline-block;
                  width: 20px;
                  margin-left: 4px;
                  i {
                    position: absolute;
                    top: 11px;
                    left: 1px;
                    height: 10px;
                    max-width: 20px;
                    background-color: #178FFD;
                  }
                }
                .set {
                  margin-left: 4px;
                  font-size: 20px;
                  cursor: pointer;
                }
              }

            }
            .chart-item {
              overflow: hidden;
              height: 232px;
              h6 {
                height: 28px;
                line-height: 28px;
                border-bottom: 1px solid #E1E1E1;
                overflow: hidden;
                .title {
                  font-size: 16px;
                  color: #000;
                  display: inline-block;
                  vertical-align: top;
                  margin-left: 5px;
                }
                .title-right {
                  font-size: 12px;
                  float: right;
                  color: #178FFD;
                  margin-top: -2px;
                  position: relative;
                  z-index: 2;
                  cursor: pointer;
                  .electric {
                    font-size: 20px;
                    cursor: pointer;
                  }
                }
              }              
              .chart {
                position: relative;
                display: inline-block;
                width: 170px;
                margin: 10px 10px;
                vertical-align: top;
                .tong-box {
                  position: relative;
                  width: 170px;
                  height: 160px;
                  img {
                    position: absolute;
                    &.tong {
                      width: 160px;
                    }
                  }
                  .water-level-box {
                    position: absolute;
                    top: 23px;
                    left: 46px;
                    p {
                      position: absolute;
                      top: 30%;
                      left: 0;
                      text-align: center;
                      width: 70px;
                      color: #178FFD;
                      font-weight: bold;
                      text-shadow: 0 1px #fff, 1px 0 #fff, -1px 0 #fff, 0 -1px #fff;
                    }
                  }
                  .long-line {
                    width: 50px;
                    top: 8px;
                    left: 10px;
                  }
                }
                .status {
                  margin: 2px auto 0px;
                  width: 42px;
                  line-height: 22px;
                  text-align: center;
                  color: #fff;
                  background: #16D585;
                  border-radius: 4px;
                  font-size: 12px;
                }
                .value {
                  text-align: center;
                }
              }
              .device-params {
                display: inline-block;
                width: 150px;
                margin-top: 20px;
                margin-left: 10px;
                >div {
                  margin-bottom: 10px;
                  color: #333;
                  font-size: 12px;
                  .params-t {
                    display: inline-block;
                    color: #178FFD;
                    border: 1px solid #178FFD;
                    padding: 0px 12px;
                    line-height: 22px;
                    font-size: 13px;
                    font-weight: bold;
                    margin-bottom: 3px;
                  }
                  // .time-t {
                  //   font-size: 10px;
                  // }
                }
              }
            }
            .bottom-item {
              position: absolute;
              bottom: 0px;
              width: calc(100% - 20px);
              border-top: 1px solid #E1E1E1;
              line-height: 34px;
              text-align: right;
              color: #B4B4B4;
              font-size: 12px;
            }
          }
          .out-card {
            h6 {
              .title {
                color: #aaa;
              }
              .title-right {
                color: #aaa;

                .sign {
                  span{
                    border: 1px solid #aaa;
                  }
                }
                .electric {
                  i {
                    background-color: #aaa;
                  }
                }
              }
            }
            .chart-item {
              h6 {
                border-bottom: 1px solid #aaa;
                .title {
                  color: #aaa;
                }
                .title-right {
                  color: #aaa;
                }
              }              
              .chart {
                .value {
                  color: #aaa;
                }
                .tong-box {
                  .water-level-box {
                    p {
                      color: #aaa;
                    }
                  }
                }
                .status {
                  background: #aaa;
                }
              }
              .device-params {
                >div {
                  color: #aaa;
                  .params-t {
                    color: #aaa;
                    border: 1px solid #aaa;
                  }
                }
              }
            }
            .bottom-item {
              color: #aaa;
            }
          }
          .alarm-card {
            .chart-item {
              h6 {
                border-bottom: 1px solid red;
                .title {
                  color: red;
                }
                .title-right {
                  color: red;
                }
              }              
              .chart {
                .value {
                  color: red;
                }
                .tong-box {
                  .water-level-box {
                    p {
                      color: red;
                    }
                  }
                }
                .status {
                  background: red;
                }
              }
              .device-params {
                >div {
                  color: red;
                  .params-t {
                    color: red;
                    border: 1px solid red;
                  }
                }
              }
            }
            .bottom-item {
              color: red;
            }
          }
        }

        &.active{
          width: 100%;
          .cardList{
            height: 100%;
            width: 100%;
            overflow-x: hidden;
            overflow-y: auto;
            &>li{
              float: left;
              width: 20%;
              height: 240px;
            }
          }
        }
      }
    }
  }
  .maskingRight{
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0,0.4);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    .listsRight {
      position: absolute;
      right: 12px;
      top: 0;
      width: 740px;
      height: 100%;
      z-index: 9999;
      box-shadow: -2px 0 10px #ccc;
      background: #fff;

      &.component-slid-open {
        position: absolute;
        top: 0;
        right: 0;
        width: 740px;
        height: 100%;
        background: #fff;
        opacity: 1;
        animation: slid-open 0.5s ease;
      }

      &.component-slid-out {
        position: absolute;
        top: 0;
        right: 0;
        width: 740px;
        height: 100%;
        background: #fff;
        animation: slid-out 0.5s ease;
      }

      .messContainer {
        width: 100%;
        height: 100%;
        // padding-left: 10px;
        box-sizing: border-box;

        .cons {
          width: 100%;
          height: 100%;
          // background: #f3f3f3;
          // background: rgba(243,243,243,1);
        }
      }
    }
  }
  .mainContent{
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
    .navShow {
      overflow: hidden;
      margin-bottom: 10px;
      border-bottom: 1px solid #f2f2f2;
    }
  }
  ::v-deep .el-dialog__wrapper {
    .el-dialog {
      .el-dialog__header {
        padding: 0;
        background-color: #1E2639;
        .el-dialog__title {
          color: #fff;
          font-size: 14px;
          line-height: 40px;
          margin-left: 22px;
        }
        .el-dialog__headerbtn {
          top: 13px;
          >i {
            color: #fff;
          }
        }
      }
    }
  }
  @keyframes slid-open{
      0%{
          transform: translateX(100%);
          opacity: 0;
      }
      100%{
          transform: translateX(0);
      }
  }
  @keyframes slid-out{
      0%{
          width: 600px;
          transform: translateX(0)
      }
      100%{
          transform: translateX(100%)
      }
  }
}
</style><style lang="scss">
.LiquidLevelCard {
  .devcieContainer{
    .query {
      .el-input {
        width: 180px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }

      .el-select {
        width: 110px;
        margin-right: 10px;

        .el-input {
          width: 110px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 36px;
            height: 36px;
          }
        }
      }
    }
    .el-loading-mask{
      background-color: unset;
    }
    .treeAside {
      position: absolute;
      width: 300px;
      height: 100%;
      padding: 15px 20px;
      left: 0;
      top: 0;
      box-sizing: border-box;

      .treeTop {
        position: absolute;
        height: 40px;
        line-height: 40px;
        font-size: 0;
        font-weight: bold;
        top: 20px;
        z-index: 10;
        // left: 30px;
        padding-left: 10px;

        .treeTopTitle {
          margin-right: 115px;
          // width: 500px;
          font-size: 18px;
          color: #333;
        }

        .el-button {
          margin-left: -24px;
        }

        .complete {
          margin-left: 10px;
        }
      }

      .treeBox {
        overflow: hidden;
        height: 100%;
        border: 1px solid #ebeef5;
        padding: 40px 0 10px;
        box-sizing: border-box;
      }

      .tree {
        height: 100%;
        overflow: auto;

        .el-tree-node__content {
          height: 40px;
        }

        .custom-tree-node {
          height: 40px;
          line-height: 40px;
          width: 100%;

          .treeLabel {
            font-size: 14px;
            display: inline-block;
            width: 130px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .treeBtn {
            float: right;

            .el-button {
              margin-left: 0;
            }
          }
        }
      }
    }
  }
  .mainContent{
    .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
      color: #7A7D81;
      font-size: 16px;
      font-weight: 500;
    }
    .el-breadcrumb__separator{
      font-size: 16px;
      color: #7A7D81;
      margin: 0 5px;
      font-weight: 500;
    }
    .el-breadcrumb__inner{
      font-size: 16px;
      color: #7A7D81 !important;
      font-weight: 500 !important;
    }
  }

  .edit-dialog {
    li {
      margin-top: 15px;
      .title {
        display: inline-block;
        width: 70px;
        margin-right: 15px;
      }
      .el-input .el-input__inner {
        height: 40px;
        line-height: 40px;
      }
    }
  }
  
  .dv-water-pond-level {
    text {
      font-weight: normal;
      font-size: 0px;
    }
    rect {
      stroke-width: 0;
      // width: 71px;
    }
     canvas {
      margin-top: 2px;
      margin-left: 2px;
      width: calc(100% - 4px);
      height: calc(100% - 4px);
      // box-sizing: border-box;
    }
  }
}
</style>
